export default "/images/home-recruit.png?e0414b422215ac1d12d6a1340512e15d";